import { render } from "./leaves-admin.vue?vue&type=template&id=61b2bed3"
import script from "./leaves-admin.vue?vue&type=script&lang=js"
export * from "./leaves-admin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__